import { z } from 'zod';

const num = () => z.coerce.number();

export const StockReconciliationFacilitySchema = z.array(z.object({
  facility_name: z.string(),
  sku_count: num(),
  total_opening_stock: num(),
  total_closing_stock: num(),
  expected_closing_stock: num(),
  rfid_inventory: num(),
  rfid_excess: num(),
  rfid_short: num(),
  good_inventory: num(),
  bad_inventory: num(),
  expected_vs_actual_diff: num(),
  rfid_vs_system_diff: num(),
  skus_with_rfid_mismatch: num(),
}));
export type StockReconciliationFacility = z.infer<typeof StockReconciliationFacilitySchema>;
